import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const DocNova = (props) => {
    const width = props.width ? props.width + 'px' : '22px';
    const height = props.height ? props.height + 'px' : '27px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 22 27"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.41225 23.3263H19.0513V6.69519H15.6815V2.81697H2.41225V23.3263ZM0 0.0737305H18.0974V3.95195H21.4783V6.69937H21.4635V23.3263H21.4783V26.0737H0V0.0737305Z"
            />
            <path d="M10.5069 5.89111H5.11523V8.63435H10.5069V5.89111Z" />
            <path d="M15.9767 17.5215H5.19336V20.5453H15.9767V17.5215Z" />
            <path d="M15.9767 11.3188H5.19336V14.3427H15.9767V11.3188Z" />
        </SvgStyled>
    );
};

export default DocNova;
